export default __webpack_public_path__ + "static/media/Formular.4fcc9e45.eot";